<template>
    <div id="on-line">
        <Breadcrumb></Breadcrumb>
        <div class="form-body">
            <el-form :ref="form" :model="form" label-width="80px" style="padding: 0 5px">
                <el-form-item label="店铺账号:">
                    <el-radio-group v-model="form.account" class="hide_input" @change="getList">
                        <el-radio label="">全部</el-radio>
                        <el-radio v-for="(item,index) in dpList" :label="item.shopId">{{item.shopName}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div style="border-top: 1px dashed #afafaf;padding-top: 5px;">
                    <el-form-item label="搜索类型:">
                        <el-radio-group v-model="form.searchType" size="small" class="hide_input" @change="getList">
                            <el-radio :label="1">标题</el-radio>
                            <el-radio :label="2">SKU</el-radio>
                            <el-radio :label="3">产品ID</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="搜索内容:">
                        <el-input size="small" v-model="form.searchStr" style="width: 30%;border: 0px;" placeholder="请输入内容"></el-input>
                        <el-button size="small" @click="showMoreSearchItem" style="margin-left: 10px">高级搜索</el-button>
                        <el-button size="small" type="primary" @click="getList" style="margin-left: 10px">搜索</el-button>

                        <!--<el-link :underline="false" @click="showMoreSearchItem" style="color: #409eff;margin-left: 10px">高级搜索</el-link>-->
                    </el-form-item>
                </div>
                <div class="detailForm" v-show="showMoreItem">
                    <el-form  :model="form" ref="form" label-width="110px" style="padding: 0 5px">
                        <el-form-item label="价格:">
                            <div class="double_item" style="display: flex;width: 93%">
                                <el-col>
                                    <el-form-item prop="price_start">
                                        <el-input v-model="form.price_start" size="small" style="width: 100%"/>
                                    </el-form-item>
                                </el-col>
                                -
                                <el-col>
                                    <el-form-item prop="price_end">
                                        <el-input v-model="form.price_end" size="small" style="width: 100%"/>
                                    </el-form-item>
                                </el-col>
                            </div>
                        </el-form-item>
                        <el-form-item label="促销价:">
                            <div class="double_item" style="display: flex;width: 93%">
                                <el-col>
                                    <el-form-item prop="pro_price_start">
                                        <el-input v-model="form.pro_price_start" size="small" style="width: 100%"/>
                                    </el-form-item>
                                </el-col>
                                -
                                <el-col>
                                    <el-form-item prop="pro_price_end">
                                        <el-input v-model="form.pro_price_end" size="small" style="width: 100%"/>
                                    </el-form-item>
                                </el-col>
                            </div>
                        </el-form-item>
                        <el-form-item label="库存:">
                            <div class="double_item" style="display: flex;width: 93%">
                                <el-col>
                                    <el-form-item prop="inventory_start">
                                        <el-input v-model="form.inventory_start" size="small" style="width: 100%"/>
                                    </el-form-item>
                                </el-col>
                                -
                                <el-col>
                                    <el-form-item prop="inventory_end">
                                        <el-input v-model="form.inventory_end" size="small" style="width: 100%"/>
                                    </el-form-item>
                                </el-col>
                            </div>
                        </el-form-item>
                        <el-row>
                            <el-col style="width: 110px">
                                <el-form-item label-width="0" prop="dateType">
                                    <el-select clearable  v-model="form.dateType" size="small" style="width: 95%" placeholder="请选择">
                                        <el-option label="更新时间" value="update"></el-option>
                                        <el-option label="创建时间" value="create"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col style="width:calc(100% - 110px)">
                                <el-form-item label-width="0" prop="dateValue">
                                    <el-date-picker
                                            size="small"
                                            style="width: 93%"
                                            v-model="dateValue"
                                            type="daterange"
                                            align="right"
                                            unlink-panels
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd"
                                            :picker-options="pickerOptions">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item>
                            <div style="text-align: right;padding-right: 10px">
                                <el-link :underline="false" style="color: #409eff;margin-left: 10px" @click="cancle_1">取消</el-link>
                                <el-link :underline="false" style="color: #409eff;margin: 0 10px" @click="resetForm">重置</el-link>
                                <el-button size="small" type="primary"  @click="getList">搜索</el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="border-top: 1px dashed #afafaf;padding-top: 5px;">
                    <el-form-item label="站点选择:">
                        <el-radio-group v-model="form.site" class="hide_input"  @change="getList">
                            <el-radio label="">全部</el-radio>
                            <el-radio v-for="(item,index) in dpzdxzList" :label="item.aSite">{{item.aSite}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="售卖形式:">
                        <el-radio-group v-model="form.sell" class="hide_input"  @change="getList">
                            <el-radio label="">全部</el-radio>
                            <el-radio v-for="(item,index) in dpsmxsList" :label="item.sellForm">{{item.sellForm}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="排序方式:">
                        <el-radio-group v-model="form.sortField" class="hide_input sort-group" @change="getList">
                            <el-radio label="UPDATE_TIME">按更新时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                            <el-radio label="CREATE_TIME">按创建时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                            <el-radio label="INVENT">按库存<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div style="padding: 10px 0px;display: inline-block;width: 100%">
            <div style="float: left">
                <el-dropdown trigger="click" @command="batchHandle">
                    <el-button type="primary" size="small">批量操作</el-button>
                    <el-dropdown-menu slot="dropdown">
                        <!--<el-dropdown-item command="1">批量复制为新产品</el-dropdown-item>-->
                        <el-dropdown-item command="2">批量下架</el-dropdown-item>
                        <el-dropdown-item command="3">批量删除</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown placement="bottom-start" trigger="click" ref="xxx">
                    <el-button size="small" type="primary" style="margin-left: 10px">移动分类<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <div class="scro">
                            <el-scrollbar style="height: 200px">
                                <el-tree style="text-align: center;margin-right: 15px" :data="ydlfTree.treeData" :props="ydlfTree.treeDefaultProps"
                                         @node-click="handleNodeClick" :default-expand-all="true" :expand-on-click-node="false"></el-tree>
                            </el-scrollbar>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div style="float: right">
                <!--<el-dropdown trigger="click" @command="batchHandle">-->
                    <!--<el-button type="primary" size="small">同步产品到xxx</el-button>-->
                    <!--<el-dropdown-menu slot="dropdown">-->
                        <!--<el-dropdown-item command="1">同步全部产品</el-dropdown-item>-->
                        <!--<el-dropdown-item command="2">同步选择产品</el-dropdown-item>-->
                    <!--</el-dropdown-menu>-->
                <!--</el-dropdown>-->
            </div>
        </div>
        <div>
            <!--<el-radio-group v-model="listType"    @change="getList">-->
                <!--<el-radio-button :label="0" name="01">所有({{stateSize.alls}})</el-radio-button>-->
                <!--<el-radio-button :label="1" name="02">有库存({{stateSize.haveInvent}})</el-radio-button>-->
                <!--<el-radio-button :label="2" name="03">无库存({{stateSize.noInvent}})</el-radio-button>-->
            <!--</el-radio-group>-->

            <div style="float: left;">
                <el-tabs v-model="listType" type="card" @tab-click="handleClick" style="background-color: white;width: 414px;margin-bottom: -15px;">
                    <el-tab-pane :label="'所有('+stateSize.alls+')'" name="01"></el-tab-pane>
                    <el-tab-pane :label="'有库存('+stateSize.haveInvent+')'" name="02"></el-tab-pane>
                    <el-tab-pane :label="'无库存('+stateSize.noInvent+')'" name="03"></el-tab-pane>
                </el-tabs>
            </div>

            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    :page-sizes="[100, 200, 300, 400]"
                    @pagination="getList"
            />

            <el-table v-loading="loading" id="outTable" ref="multipleTable" :data="tableData" header-cell-class-name="table-header"
                      style="width: 100%" @selection-change="handleSelectionChange"  row-key="pId"
                      lazy
                      :load="loadSku"
                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="mainPic" label="图片" width="115" align="center">
                    <template scope="scope">
                        <span v-if="scope.row.hasOwnProperty('children')" style="font-size: 13px">变体：({{scope.row.children.length}})</span>
                        <el-popover v-else placement="right" width="300" trigger="hover">
                            <div style="text-align: right;background-color: rgba(239,239,239,1);height: 25px;line-height: 25px">
                                <span style="padding-right: 20px">找货源</span>
                            </div>
                            <img class="img-big" :src="scope.row.mainPic" style="width: 300px;height: 300px;object-fit: contain"/>
                            <img style="width:80px;height: 80px;object-fit: contain;border:1px solid #ccc" slot="reference" class="img-small" :src="scope.row.mainPic"/>
                            <div slot="reference">
                                <span style="font-size: 12px">来源：</span>
                                <a style="text-decoration: none;color: #409eff;font-size: 12px"
                                   :href="scope.row.dataUrl" target="_blank">{{foramtDataSource(scope.row.dataSource)}}</a>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="proTitle" label="标题/ASIN/成色" width="300" align="center">
                    <template slot-scope="scope">
                        <el-row style="text-align: center">{{scope.row.proTitle}}</el-row>
                        <div style="padding-left: 20px;margin-top: 20px">
                            <el-row style="color: #8a8a8a" v-show="scope.row.dpxs">店铺[{{scope.row.shopName}}]</el-row>
                            <el-row v-if="scope.row.hasOwnProperty('children')">备注:{{scope.row.remark}}</el-row>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="skuno" label="SKU/商品编码" align="center">
                    <!--<template slot-scope="scope">-->
                    <!--<span>{{scope.row.sAmazonSku.skuno}}</span><br/>-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column label="国家" align="center" prop="aSite"></el-table-column>
                <el-table-column label="售价" prop="price" align="center">
                    <!--<template slot-scope="scope">-->
                    <!--<span>{{scope.row.sAmazonSku[0].price}}</span><br/>-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column label="库存" prop="invent" align="center">
                    <!--<template slot-scope="scope">-->
                    <!--<span>{{scope.row.sAmazonSku[0].invent}}</span><br/>-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column prop="createTime" label="时间" align="center">
                    <template slot-scope="scope">
                        <el-row>创建:</el-row>
                        <el-row>{{scope.row.createTime}}</el-row>
                        <el-row>更新:</el-row>
                        <el-row>{{scope.row.updateTime}}</el-row>
                    </template>
                </el-table-column>
                <el-table-column prop="handel" label="操作" align="center" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.hasOwnProperty('children')">
                            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
                            <br/>
                            <el-button type="text" size="mini" @click="addRemark(scope.row)" >添加备注</el-button>
                            <br/>
                            <el-button type="text" size="mini" @click="deleteRow(scope.row)" >删除</el-button>
                            <br/>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>


            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    :page-sizes="[100, 200, 300, 400]"
                    @pagination="getList"
            />
        </div>
        <el-dialog :close-on-click-modal="false"   title="添加备注" width="35%" :visible.sync="noteDialogVisible" class="note-dialog">
            <el-row style="display: flex;align-items: center">
                <el-col :span="2">
                    <p>内容:</p>
                </el-col>
                <el-col :span="22">
                    <el-input placeholder="请输入介绍信息"  v-model="form.remark" type="textarea" :rows="10">

                    </el-input>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="noteDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitRemark(form.remark)" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {loadDataZxcp,loadDpmc,loadZdxz,loadSmxs,updateAmazonRemark,singledeleteAmazon,batchDeleteByIDs,batchdeleteAmazon,getTreeList,lowerShelfProduct,getProductStateList,loadTableData} from '@/api/product/amazon'
    import {getTree} from '@/api/tree/tree';

    export default {
        name: "onLine",
        components:{Breadcrumb},
        data() {
            return {
                loading:false,
                total: 0,
                currentPage: 1,
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                form: {
                    pageNum: 1,
                    pageSize: 10,
                    account: '',
                    searchStr: null,
                    dataSource: '',//数据来源
                    searchType: 1,
                    site: '',//站点选择
                    sell: '',//售卖形式
                    sortField: 'UPDATE_TIME',//排序方式
                    price_start: null,
                    price_end: null,
                    pro_price_start: null,
                    pro_price_end: null,
                    inventory_start: null,
                    inventory_end: null,
                    dateType: 'update',
                    remark: '',
                    pId: null,
                    dateStart: '',
                    dateEnd: '',
                },
                dateValue: null,
                dpxs: true,
                bzxs: true,
                cz: true,
                zcd: false,
                fcd: true,
                props: {
                    id: 'id',
                    children: 'children',
                    label: 'typeNme'
                },
                tableData: [],
                showMoreItem: false,
                dpzdxzList: [],
                dpsmxsList: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                dataType: 0,
                ydlfTree: {
                    treeData: [],
                    treeDefaultProps: {
                        children: 'children',
                        label: 'label',
                        value: 'value',
                        pCatId: 'pCatId'
                    },
                },
                listType: '0',
                noteDialogVisible: false,//备注弹框
                ids: [], //选中的ID
                shopeeList: [],//批量对象
                //产品的状态
                stateSize: {
                    alls: 0, //所有
                    haveInvent: 0, //有库存
                    noInvent: 0//无库存
                },
                accordInvent:''
            }
        },
        computed:{
            treeId(){
                return this.$route.query.treeId;
            },
            dpList(){
                return this.$store.state.product.amazon.shopList;
            }
        },
        watch:{
            treeId(){
                this.dateValue=null;
                this.getList()
            },
        },
        created() {
            var that = this;
            that.getZdxz();
            that.getSmxs();
            that.getList();
            that.getMoveClassification();
            // that.getProductStateList();
        },
        methods: {

            handleNodeClick(val) {
                if (this.ids.length <= 0){
                    this.msgError("请选择需要移动分类的商品");
                    //点击后消失,防止多次点击
                    this.$refs.xxx.visible =false
                    return
                }
                var pIds = this.ids.join(",")
                var shopeeList = this.shopeeList;
                this.$confirm('是否确认把这' + this.ids.length + '条数据项批量移入分类--><span style="color: red">'+val.label+'</span>吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    //显示HTML
                    dangerouslyUseHTMLString: true,
                    type: "warning"
                }).then(function() {
                    var data ={
                        'typeNo':val.value,
                        'pIds':pIds,
                    }
                    return updateTypeNo(data);
                }).then(() => {
                    this.getList();
                    this.msgSuccess("移入分类成功");
                }).catch(function() {});
                //点击后消失,防止多次点击
                this.$refs.xxx.visible =false
            },

            loadNode(node, resolve) {
                var that =this;
                if (node.level === 0) {
                    //查询顶级节点
                    let params = {};
                    getTreeList(params).then(function(res){
                        that.treeData = that.createTreeData(res.data);
                        return resolve(that.treeData);
                    }).catch(function(error){
                        this.$message.error(res.msg);
                    });
                }else {
                    let params = {pTypeNo:node.data.id};
                    // 根据父节点id找寻下一级的所有节点
                    getTreeList(params).then(res => {
                        return resolve(res.data);
                });
                }

            },

            createTreeData(data){
                let treedata = data.filter(father =>{
                    if(father['pTypeNo'] == ""||father['pTypeNo'] == null){
                    father['pTypeNo'] = '0'
                }
                let childArr = data.filter(child =>{
                    return  child['pTypeNo'] == father.id;
            });
                childArr.length > 0?father.children =childArr:'';
                return father['pTypeNo'] == '0';
            });
                return treedata ;
            },

            setClassManage:function(){
                this.classManageDialog = true;
            },

            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
            show: function() {

            },
            showMoreSearchItem:function(){
                this.showMoreItem = !this.showMoreItem;
            },
            cancle_1:function(){
                this.showMoreItem = false;
                this.$refs['form'].resetFields()
                this.dateValue=null;
                this.form.dateStart = null;
                this.form.dateEnd = null;
            },

            loadSku(tree, treeNode, resolve){
                var xalist =[]

                for (var i =0 ; i<tree.sAmazonSku.length;i++){
                    var  aa=
                        {
                            bzxs:false,
                            dpxs:false,
                            cz:false,
                            zcd:true,
                            fcd:false,
                            pId: tree.sAmazonSku[i].skuid,
                            mainPic: tree.mainPic,
                            proTitle:tree.proTitle,
                            skuno:tree.sAmazonSku[i].skuno,
                            aSite:tree.aSite,
                            price:tree.sAmazonSku[i].price,
                            invent:tree.sAmazonSku[i].invent,
                            createTime:tree.createTime,
                            updateTime:tree.updateTime
                        }
                    xalist.push(aa);

//                   xalist['pId']= tree.sAmazonSku[i].skuid;
//                   xalist['mainPic']= tree.mainPic;
//                    xalist['proTitle']= tree.proTitle;
//                    xalist['skuno']= tree.sAmazonSku[i].skuno;
//                    xalist['aSite']= tree.aSite;
//                    xalist['price']= tree.sAmazonSku[i].price;
//                    xalist['invent']= tree.sAmazonSku[i].invent;
//                    xalist['createTime']= tree.createTime;
//                    xalist['updateTime']= tree.updateTime;
                }
                resolve(xalist)
//                this.form['id']=tree.pId;
//                loadData(this.form).then((res) =>{
////                    res.rows[0].pId=9923493438
//                    resolve(res.data)
//                })
            },



            // getList: function() {
            //     this.form.dateStart="";
            //     this.form.dateEnd="";
            //     this.loading = true;
            //     if (this.treeId != 1){
            //         this.form['typeNo']=this.treeId
            //     }else{
            //         this.form['typeNo']="";
            //     }
            //     if (this.dateValue!=null){
            //         this.form.dateStart=this.dateValue[0];
            //         this.form.dateEnd=this.dateValue[1];
            //     }
            //     this.form['pubStatus']="05";
            //     loadDataZxcp(this.form).then((res) => {
            //         this.tableData = res.rows;
            //         this.total = res.total;
            //         this.loading = false;
            //         this.getProductStateList();
            //     })
            // },


            //获取第一节点
            getList: function () {
                this.loading = true;
                this.form['pubStatus']="05";//发布状态pubStatus，01采集箱，02待发布，03发布中，04发布失败，05在线产品
                if (this.treeId != 0){
                    this.form['typeNo']=this.treeId
                }else{
                    this.form['typeNo']="";
                }
                if (this.dateValue!=null){
                    this.form.dateStart=this.dateValue[0];
                    this.form.dateEnd=this.dateValue[1];
                }
                loadTableData(this.form).then(res =>{
                    if(res.code == 200){
                        //对数据进行处理
                        this.preHandleData(res.rows);
                        this.total = res.total;
                        this.$store.dispatch('setIfReload',true);
                        this.getProductStateList();
                    }
                    this.loading = false;
                }).catch(err =>{
                    this.loading = false;
                });
            },
            preHandleData(data){
                let finalData = [];
                let temp = [];
                data.forEach(row =>{
                    let map ={collId:row.collId,
                        createTime:row.createTime,
                        updateTime:row.updateTime,
                        pId:row.pId,
                        proTitle:row.proTitle,
                        remark:row.remark,
                        dataSource:row.dataSource,
                        dataUrl:row.dataUrl,
                        children:[]
                    }

                    if(temp.indexOf(JSON.stringify(map)) == -1){
                        temp.push(JSON.stringify(map));
                    }
                });
                temp.forEach(str =>{
                    finalData.push(JSON.parse(str));
                })
                finalData.forEach(head =>{
                    data.forEach((row,index) =>{

                        if(head.pId == row.pId){
                            row.pId +=  '_' + row.skuId;
                            head.children.push(row);
                        }
                    });
                })
                this.tableData = finalData;

                let tableData = this.tableData;
            },

            getZdxz: function() {
                this.loading = true;
                loadZdxz().then((res) => {
                    this.dpzdxzList = res.rows;
                this.loading = false;
            })
            },
            getSmxs: function() {
                this.loading = true;
                loadSmxs().then((res) => {
                    this.dpsmxsList = res.rows;
                this.loading = false;
            })
            },

            addRemark(row){
                this.noteDialogVisible=true;
                this.form.remark=row.remark;
                this.form.pId=row.pId;
            },

            //提交备注
            submitRemark(remark){
                updateAmazonRemark(this.form).then((res) => {
                    if (res.code === 200) {
                    this.msgSuccess("修改成功");
                    this.getList();
                    this.noteDialogVisible = false;
                }
            })
            },

            batchHandle: function(val) {
                if ("1" == val) {
                    //将亚马逊平台商品同步到本平台

                } else if("2"== val) {
                    // this.batchUpdate();
                    this.batchLowerShelfProduct();
                }else {
                    this.batchDelete();
                }
            },
            //批量删除
            batchDelete() {
                const ids =this.ids;
                if (ids.length <= 0){
                    this.msgError("请选择需要删除的商品");
                    return
                }
                this.$confirm('是否确认删除选择的' + this.ids.length + '条数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return batchdeleteAmazon(ids);
                }).then(() => {
                    this.getList();
                    this.$store.dispatch('setIfReload',true);
                this.msgSuccess("删除成功");
            }).catch(function() {});
            },
//            批量待发布
            batchUpdate() {
                const shopeeList = this.shopeeList;
                if (this.shopeeList.length==0){
                    this.msgError("批量待发布至少选择一条数据");
                    return
                }
                this.$confirm('是否确认把这' + this.shopeeList.length + '条数据项批量移入待发布', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return batchDeleteByIDs(JSON.stringify(shopeeList));
                }).then(() => {
                    this.getList();
                    this.$store.dispatch('setIfReload',true);
                    this.msgSuccess("修改成功");
            }).catch(function() {});
            },

            //用户勾选
            handleSelectionChange(val) {
                this.ids=[];
                this.shopeeList=[];
                //获取当前用户
                var userName = this.$store.state.user.name;
                val.forEach((item) => {
                    //批量移入待发布
                    var updateStatePara={
                        "pId":item.pId,
                        "pubStatus":'01',
                        "operNo":userName,

                    };
                this.ids.push(item.pId);
                this.shopeeList.push(updateStatePara);

            });
            },

            foramtDataSource(val){
                if(val == '01'){
                    return "1688";
                }else if(val == '02'){
                    return "速卖通";
                }else if(val == '03'){
                    return "Lazada";
                } else if(val == '04'){
                    return "Amazon";
                } else if(val == '05'){
                    return "Shopee";
                }
                return "未知";
            },


            handleSizeChange: function(val) {
                console.log(`每页: ${val}条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            edit: function(row) {
                this.$router.push({path: "/product/amazon/onLineEdit", query: {pId: row.pId}})
            },
            addNote: function() {
                this.noteDialogVisible = true;
            },
            deleteRow(row) {
//                let pId = row.pId;
                this.$confirm('是否确认删除Amazon产品标题为<span style="color: red">' + row.proTitle + '</span>的数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    //显示HTML
                    dangerouslyUseHTMLString: true,
                    type: "warning"
                }).then(function() {
                    return singledeleteAmazon(row.pId);
                }).then(() => {
                    this.getList();
                this.msgSuccess("删除成功");
            }).catch(function() {});
            },
            //清空表单
            resetForm:function(){
                this.$refs['form'].resetFields()
                this.dateValue=null;
                this.form.dateStart = null;
                this.form.dateEnd = null;
            },
            //移动分类树形数据
            getMoveClassification(that){
                getTree().then((res) => {
                    this.ydlfTree.treeData=res.data;
                })
            },
            //批量下架产品
            batchLowerShelfProduct(){
                var length = this.ids.length;
                var join = this.ids.join("-");
                if (length <=0){
                    this.msgError("请选择需要下架的产品");
                    return;
                }
                this.$confirm('是否确认把这'+length+'条产品下架?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return lowerShelfProduct(join);
                }).then(() => {
                    this.getList();
                    this.$store.dispatch('setIfReload',true);
                    this.msgSuccess("下架产品成功");
                }).catch(function() {});
            },
            //获取商品的各种状态数量
            getProductStateList(){
                getProductStateList(this.form).then((res) => {
                   if(res.code == 200){
                       this.stateSize.alls=res.data.alls;
                       this.stateSize.haveInvent=res.data.haveInvent;
                       this.stateSize.noInvent=res.data.noInvent;
                   }
                });
            },
            //点击TAB标签触发
            handleClick(tab, event) {
                this.form.accordInvent = tab.name;
                this.getList();
            },
            turnWay(e){
                var classVal =  e.target.className;
                if(classVal == 'el-icon-caret-top'){
                    e.target.setAttribute('class','el-icon-caret-bottom');
                    this.form.byAsc = 'desc';
                }else{
                    e.target.setAttribute('class','el-icon-caret-top');
                    this.form.byAsc = 'asc';
                }
                this.getList();
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>
    @import '../../../assets/css/product.css';
    #ready-release{
        width: 100%;
    }
    .detailForm{
        padding-top: 5px;
        margin-left: 85px;
        width: 50%;
        height: auto;
        margin-bottom: 8px;
    }
    .detailForm .el-form-item,.sea_cont{
        margin-bottom: 10px !important;
    }
    .double_item .el-form-item{
        margin-bottom: 0px !important;
    }
    .scro >>> .el-scrollbar__wrap {
        overflow-x: hidden;
    }
</style>
